import { render, staticRenderFns } from "./CoachTodo.vue?vue&type=template&id=763b3e4a&scoped=true&"
import script from "./CoachTodo.vue?vue&type=script&lang=js&"
export * from "./CoachTodo.vue?vue&type=script&lang=js&"
import style0 from "./CoachTodo.vue?vue&type=style&index=0&id=763b3e4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763b3e4a",
  null
  
)

export default component.exports